import request from '@/axios'
import type {
  // UserType,
  PhoneUserType,
  CaptchaType,
  LoginResponseType,
  LoginFormType
} from './types'
/** 获取当前用户角色路由 */
export const getUserRoleRoutersApi = async (): Promise<IResponse<{ list: AppCustomRouteRecordRaw[] }>> => {
  return request.post({ url: '/menu/navigation' })
}

// interface RoleParams {
//   roleName: string
// }

// export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
//   return request.post({ url: '/mock/user/login', data })
// }

// export const loginOutApi = (): Promise<IResponse> => {
//   return request.get({ url: '/mock/user/loginOut' })
// }

// export const getUserListApi = ({ params }: AxiosConfig) => {
//   return request.get<{
//     code: string
//     data: {
//       list: UserType[]
//       total: number
//     }
//   }>({ url: '/mock/user/list', params })
// }

// export const getAdminRoleApi = (
//   params: RoleParams
// ): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
//   return request.get({ url: '/mock/role/list', params })
// }

// export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
//   return request.get({ url: '/mock/role/list2', params })
// }

// export const phoneLoginApi = (data: PhoneUserType): Promise<IResponse<LoginResponseType>> => {
//   return request.post({ url: '/mock/user/phoneLogin', data })
// }

// export const sendSmsCodeApi = (phone: string): Promise<IResponse> => {
//   return request.post({ url: '/mock/user/sendSmsCode', data: { phone } })
// }

//账号密码登录
export const accountLoginApi = (data: LoginFormType): Promise<IResponse<LoginResponseType>> => {
  return request.post({ url: '/login/account', data })
}

//图片验证码
export const getCaptchaApi = (): Promise<IResponse<CaptchaType>> => {
  return request.get({ url: '/login/captcha' })
}

//短信验证码登录
export const phoneLoginApi = (data: PhoneUserType): Promise<IResponse<LoginResponseType>> => {
  return request.post({ url: '/login/verify_code', data })
}

//获取短信验证码
export const sendSmsCodeApi = (phone_number: string): Promise<IResponse> => {
  return request.post({ url: '/sms_verify_code', data: { phone_number } })
}

//退出登录
export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/user/logout' })
}
